"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _MobileRoomGallery = _interopRequireDefault(require("../MobileRoomGallery"));
var _Tab = _interopRequireDefault(require("../Tab"));
var _Tabs = _interopRequireDefault(require("../Tabs"));
var _LabelList = require("../Label/LabelList");
var _HotelOffersTableMobile = _interopRequireDefault(require("../HotelOffersTableMobile"));
var _HotelRoomFacilities = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomFacilities"));
var _HotelRoomOffersSkeleton = _interopRequireDefault(require("../HotelRoomOffersSkeleton/HotelRoomOffersSkeleton"));
var _EmptyGallery = _interopRequireDefault(require("../EmptyGallery"));
var _hotel = require("../../proptypes/hotel");
var _HotelRoomName = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomName"));
var _CashBack = _interopRequireDefault(require("../CashBack"));
var _excluded = ["room", "nights", "offers", "selectedNights", "mealTypes", "hotelFacilities", "onOfferClicked", "labels", "bonusCount", "isHotelOnly", "isWhiteLabel", "onClickGallery", "labelColor", "textColor", "cashbackTooltipText", "className", "size", "cashbackLabel", "hasCashbackLabel", "cashbackIconWebp", "cashbackIconPng"]; // Components:
// PropTypes:
// Utils:
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TABS = {
  price: {
    id: 'price',
    label: _localization.i18n.t('hotel.room.price'),
    // unfortunally we can't make flexible shapes
    width: 55
  },
  facilities: {
    id: 'facilities',
    label: _localization.i18n.t('hotel.room.facilities_mobile'),
    width: 135
  }
};

// ms to set slide visually active.
var SLIDE_CHANGE_DELAY = 100;
var HotelRoomOfferMobile = function HotelRoomOfferMobile(props) {
  var room = props.room,
    nights = props.nights,
    offers = props.offers,
    selectedNights = props.selectedNights,
    mealTypes = props.mealTypes,
    hotelFacilities = props.hotelFacilities,
    onOfferClicked = props.onOfferClicked,
    labels = props.labels,
    bonusCount = props.bonusCount,
    isHotelOnly = props.isHotelOnly,
    isWhiteLabel = props.isWhiteLabel,
    onClickGallery = props.onClickGallery,
    labelColor = props.labelColor,
    textColor = props.textColor,
    cashbackTooltipText = props.cashbackTooltipText,
    className = props.className,
    size = props.size,
    cashbackLabel = props.cashbackLabel,
    hasCashbackLabel = props.hasCashbackLabel,
    cashbackIconWebp = props.cashbackIconWebp,
    cashbackIconPng = props.cashbackIconPng,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var roomName = room.name_ru,
    roomNameEn = room.name_en,
    area = room.area,
    facilities = room.facilities,
    description = room.description,
    images = room.images,
    idRoom = room.id;
  var _useState = (0, _react.useState)(nights.indexOf(selectedNights)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  var _useState3 = (0, _react.useState)(TABS.price.id),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedTab = _useState4[0],
    setSelectedTab = _useState4[1];
  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  var onSlideChange = (0, _react.useMemo)(function () {
    return function (slide) {
      return setTimeout(setActiveSlide(slide), SLIDE_CHANGE_DELAY);
    };
  }, []);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    rendered = _useState6[0],
    setRendered = _useState6[1];
  (0, _react.useEffect)(function () {
    var timeout;
    if (!rendered) {
      timeout = setTimeout(function () {
        return setRendered(true);
      }, 0);
    }
    return function () {
      clearTimeout(timeout);
    };
  });
  if (!rendered) {
    return /*#__PURE__*/_react["default"].createElement(_HotelRoomOffersSkeleton["default"], (0, _extends2["default"])({}, rest, {
      isMobile: true
    }));
  }
  var existRoomImages = !(0, _isEmpty2["default"])(roomImages);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomOfferMobile, rest, bonusCount ? /*#__PURE__*/_react["default"].createElement(_CashBack["default"], {
    count: "+".concat(bonusCount),
    isMobile: true,
    labelColor: labelColor,
    textColor: textColor,
    cashbackTooltipText: cashbackTooltipText,
    className: "hotelMobile",
    size: size,
    label: cashbackLabel,
    hasCashbackLabel: hasCashbackLabel,
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng,
    existRoomImages: existRoomImages
  }) : null, existRoomImages ? /*#__PURE__*/_react["default"].createElement(StyledGallery, {
    onClickGallery: onClickGallery,
    images: roomImages,
    id: idRoom
  }) : /*#__PURE__*/_react["default"].createElement(_EmptyGallery["default"], null), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_HotelRoomName["default"], {
    name: roomName,
    originalName: roomNameEn,
    area: area,
    gap: 4,
    headerFontSize: 16
  }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
    labels: labels,
    maxLabels: 6
  }), /*#__PURE__*/_react["default"].createElement(StyledTabs, {
    onChange: setSelectedTab
  }, Object.values(TABS).map(function (_ref) {
    var id = _ref.id,
      label = _ref.label,
      width = _ref.width;
    return /*#__PURE__*/_react["default"].createElement(StyledTab, {
      key: id,
      value: id,
      selected: selectedTab === id,
      width: width
    }, label);
  }))), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.price.id
  }, /*#__PURE__*/_react["default"].createElement(_HotelOffersTableMobile["default"], {
    offers: offers,
    nights: nights,
    mealTypes: mealTypes,
    onOfferClicked: onOfferClicked,
    onSlideChange: onSlideChange,
    activeSlide: activeSlide,
    selectedNights: selectedNights,
    isHotelOnly: isHotelOnly,
    isWhiteLabel: isWhiteLabel
  })), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.facilities.id
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelRoomFacilities, {
    facilities: facilities,
    description: description,
    hotelFacilities: hotelFacilities,
    isMobile: true
  })));
};
HotelRoomOfferMobile.propTypes = {
  className: _propTypes["default"].string,
  onOfferClicked: _propTypes["default"].func.isRequired,
  room: _hotel.RoomPropTypes.isRequired,
  mealTypes: _propTypes["default"].arrayOf(_hotel.MealTypePropTypes).isRequired,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired,
  nights: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  selectedNights: _propTypes["default"].number.isRequired,
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  bonusCount: _propTypes["default"].number,
  isWhiteLabel: _propTypes["default"].bool
};
HotelRoomOfferMobile.defaultProps = {
  className: '',
  hotelFacilities: null,
  labels: []
};
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelRoomOffersMobile__StyldLabelList",
  componentId: "sc-1mh2rvq-0"
})(["margin-top:8px;"]);
var StyledTab = (0, _styledComponents["default"])(_Tab["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledTab",
  componentId: "sc-1mh2rvq-1"
})(["button{font-size:14px;font-style:normal;font-weight:500;line-height:16px;padding:8px 12px;", "}"], function (_ref2) {
  var selected = _ref2.selected;
  return selected ? (0, _styledComponents.css)(["background-color:var(--background);border-radius:var(--border-radius);"]) : (0, _styledComponents.css)(["background-color:inherit;"]);
});
var StyledTabs = (0, _styledComponents["default"])(_Tabs["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelRoomOffersMobile__StyledTabs",
  componentId: "sc-1mh2rvq-2"
})(["display:flex;gap:4px;margin:10px 0;"]);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledWrapper",
  componentId: "sc-1mh2rvq-3"
})(["margin-top:6px;margin-left:10px;"]);
var StyledHotelRoomOfferMobile = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledHotelRoomOfferMobile",
  componentId: "sc-1mh2rvq-4"
})(["padding:8px;border-radius:var(--border-radius);background:var(--white);position:relative;width:100%;"]);
var StyledHotelRoomFacilities = (0, _styledComponents["default"])(_HotelRoomFacilities["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledHotelRoomFacilities",
  componentId: "sc-1mh2rvq-5"
})(["margin:10px;"]);
var StyledGallery = (0, _styledComponents["default"])(_MobileRoomGallery["default"]).withConfig({
  displayName: "HotelRoomOffersMobile__StyledGallery",
  componentId: "sc-1mh2rvq-6"
})(["border-radius:var(--border-radius);overflow:hidden;"]);
var StyledTabContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersMobile__StyledTabContent",
  componentId: "sc-1mh2rvq-7"
})(["display:", ";"], function (_ref3) {
  var isVisible = _ref3.isVisible;
  return isVisible ? 'block' : 'none';
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelRoomOfferMobile);